import { isFunction } from "./utils";
import { getClientRect } from "./web-utils";

export function elemHeight(elem: any, height: any) {
  if (elem?.style) {
    elem.style.height = height;
  }
}

export function setElementSizes(
  elem: any,
  h: number,
  w: number,
  unit = 'px'
) {
  if (elem) {
    elem.style.width = w + unit;
    elem.style.height = h + unit;
  }
}

export function tryToScrollY(el: any, posY: number) {
  el && isFunction(el.scrollTo) && el.scrollTo({
    top: posY,
    left: 0,
    behavior: 'smooth'
  });
}

export function tryToScrollDown(el: any) {
  const elRect = getClientRect(el);
  elRect && tryToScrollY(el, elRect.height + 200);
}

export function setMainElementSize(
  wrapper: any,
  size: number
): void {
  const r1 = getClientRect(wrapper);
  if (r1 && r1.top) {
    const newHeight = window.innerHeight -
      r1.top - size;

    wrapper.style.height = newHeight + 'px';
    //wrapper.style.overflowY = 'hidden';
  }
}

/**
 *
 */
export function setTopElementSize(
  wrapper: any,
  topElement: any,
  bottomElement: any,
  size: number
): void {
  const r1 = getClientRect(wrapper);
  const br = getClientRect(bottomElement);

  if (topElement && r1 && br) {
    if (r1.top && br.height) {
      const newHeight = window.innerHeight -
        r1.top - br.height - size;

      topElement.style.height = newHeight + 'px';
      //wrapper.style.overflowY = 'hidden';
    }
  }
}

export function setWrapperElementSize(
  wrapper: any,
  size: number
): void {
  const r1 = getClientRect(wrapper);

  if (wrapper && r1) {
    if (r1.top) {
      const newHeight = window.innerHeight - r1.top - size;
      wrapper.style.height = newHeight + 'px';
      //wrapper.style.overflowY = 'hidden';
    }
  }
}
